import { AUTH_TOKEN_STORAGE_KEY } from '@/app/modules/login/services/login-api';
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

export const authGuard: CanMatchFn = () => {
  const router = inject(Router);
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEY) ? true : router.createUrlTree(['/login']);
};
